import { isMock } from '../config'
import { withOfflineCache } from '../offline-cache'
import { ayudaMock } from './mock'
import { ayudaReal } from './real'
import type { AyudaService } from './types'

const impl: AyudaService = isMock('ayuda') ? ayudaMock : ayudaReal

/** El contacto y el teléfono de emergencias siguen disponibles sin conexión (DESIGN.md §7; D18). */
export const ayudaService: AyudaService = {
  getContact: (stay, signal) => withOfflineCache(stay.guestCode, 'contact', () => impl.getContact(stay, signal)),
  getFaq: (stay, signal) => withOfflineCache(stay.guestCode, 'faq', () => impl.getFaq(stay, signal)),
  getConversation: (stay, signal) => impl.getConversation(stay, signal),
}
export type { AyudaService, Contact, ConversationMessage, FaqItem, HelpStay, MessageChannel } from './types'
